import { render, staticRenderFns } from "./index-udf.vue?vue&type=template&id=143ada56"
import script from "./index-udf.vue?vue&type=script&lang=js"
export * from "./index-udf.vue?vue&type=script&lang=js"
import style0 from "./index.sass?vue&type=style&index=0&prod&lang=sass&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports